import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Loginpage from '../views/Loginpage.vue'
import Topuppage from '../views/Topuppage.vue'
import Fail_report from '../views/Fail_report'
import Asynctest from '../views/Asynctest'
import {store} from '../store/store';
Vue.use(VueRouter)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if(store.getters.isLogin){
        next();
      }
      else{
        next('/');
      }
     
    }
  },
  {
    path: '/',
    name: 'Loginpage',
    component: Loginpage,
  },
  {
    path: '/Topuppage',
    name: 'Topuppage',
    component: Topuppage,
    beforeEnter: (to, from, next) => {
      if(store.getters.isLogin){
        next();
      }
      else{
        next('/');
      }
     
    }
  },
  {
    path: '/Fail_report',
    name: 'Failreport',
    component: Fail_report,
    beforeEnter: (to, from, next) => {
      if(store.getters.isLogin){
        next();
      }
      else{
        next('/');
      }
     
    }
  },
  {
    path: '/async',
    name: 'async',
    component: Asynctest,
    beforeEnter: (to, from, next) => {
      if(store.getters.isLogin){
        next();
      }
      else{
        next('/');
      }
     
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  store,  
})


export default router
